module.exports = __webpack_public_path__ + "static/media/Icon_13.bf360f9b.svg";